
const getProfielService = actionCallback => {
    const memberId = localStorage.getItem("memberId")
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    fetch(baseUrl + "/rest/profile/read/" + memberId + "/?Authorization=" + token, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else if (res.status === 401) {
               
                // localStorage.clear();
                //  this.props.history.push("/")
                let errorOut= "logout"
                actionCallback(errorOut)
                this.props.history.push('/SessionOut')
            
               
            }
            else {
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getProfielService;


// WEBPACK FOOTER //
// ./src/services/components/get_profile.jsx